import createLazyComponent from '../LazyComponent';

const DomainTransferWrapper = createLazyComponent(() => import('./DomainTransferWrapperPage'));

export default DomainTransferWrapper;
